// ChildFuelAccordion.js
import { Accordion, AccordionSummary, Typography, IconButton } from "@mui/material";
import { useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { MDBCol } from "mdbreact";
import NonBlendFuelRegistryForm from "./NonBlendFuelRegistryForm";
import _, { set } from "lodash";
import { AbsDropDown } from "abs-ui-components";
import { calcCo2Eq, calcEnergyPercentages, calcLcvs, calcMassPercentages } from "./BlendCalculations";

const BlendChildFuelAccordion = ({
    index,
    category,
    blendChildFuels,
    setBlendChildFuels,
    blendCategories,
    setBlendCategories,
    expandedMainPanel,
    handleMainChange,
    baseFuels,
    vesselMstId,
    removeBlendFuel,
    onparentCo2Update,
    onparentMassUpdate,
    showErrors,
    createFuel,
    isInvalid,
    fuelRegId
}) => {
    const handleFuelChange = (index, update, updatedCategories) => {
        setBlendChildFuels(prev => {
            const updated = [...prev];
            const prevFuel = updated[index];
            const nextFuel =
                typeof update === "function" ? update(prevFuel) : update;

            const newCategory = updatedCategories ? updatedCategories[index] : blendCategories[index];
            const fuelToSet =
                prevFuel.categoryType !== newCategory
                    ? {
                        ...createFuel({
                            vesselMstId,
                            categoryType: newCategory,
                        }),
                    }
                    : {
                        ...nextFuel,
                        categoryType: newCategory,
                    };

            updated[index] = fuelToSet;

            let newChildFuels = calcMassPercentages(updated);
            newChildFuels = calcLcvs(newChildFuels);
            newChildFuels = calcEnergyPercentages(newChildFuels);
            newChildFuels = calcCo2Eq(newChildFuels);
            onparentCo2Update?.(newChildFuels);
            onparentMassUpdate?.(newChildFuels);

            return newChildFuels;
        });
    };

    return (
        <Accordion
            key={index}
            expanded={expandedMainPanel === `panel${index}`}
            onChange={handleMainChange(`panel${index}`)}
            style={{ marginBottom: "5px" }}
        >
            <AccordionSummary className="accordion-header">
                <Typography>{`Fuel Type ${index + 1}`}</Typography>
                {index >= 2  && (
                    <IconButton
                    sx={{marginLeft:"Auto"}}
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            removeBlendFuel(index);
                        }}
                    >
                        <CloseIcon fontSize="small" style={{ color: "white" }} />
                    </IconButton>
                )}
            </AccordionSummary>
            <div style={{ padding: "10px" }}>
                <MDBCol md="3" style={{ marginLeft: "-12px" }}>
                    <div>Fuel Classification</div>
                    <AbsDropDown
                        options={[
                            { label: "Fossil", value: "Fossil" },
                            { label: "Biofuel", value: "Biofuel" },
                            { label: "e-Fuel", value: "e-Fuel" },
                            {label:"Other Fuel",value:"Other"}
                        ]}
                        selected={category}
                        disabled={false}
                        handleChange={(o) => {
                            const newCategory = o.value;
                            const updated = [...blendCategories];
                            updated[index] = o.value;
                            setBlendCategories(prev => {
                                const next = [...prev];  
                                next[index] = newCategory; 
                                return next;
                            });
                            handleFuelChange(index, () => ({
                                ...createFuel({
                                    vesselMstId,
                                    categoryType:newCategory 
                                })
                            }),updated);

                        }}
                    />
                </MDBCol>

                <NonBlendFuelRegistryForm
                    filteredBaseFuels={_.filter(baseFuels, x => x.categoryType === category)}
                    fuelState={blendChildFuels[index]}
                    onFuelChange={(update) => handleFuelChange(index, update)}
                    showErrors={showErrors }
                    isBlendChild={true}
                />
            </div>
        </Accordion>
    );
};

export default BlendChildFuelAccordion;
